export default __webpack_public_path__ + "static/media/okBlue.a6ac5e88.svg";